import React from 'react';
import { useHistory } from 'react-router';

import backArrow from '../../../images/backArrow.png';
import vaccineCerti from '../../../images/vaccineCerti.svg';
import nextArrow from '../../../images/nextArrow.png';

import useTranslation from '../../../hooks/use-translation';

const VaccinationCertiCat = () => {
  const history = useHistory();
  const {t} = useTranslation();
  const urlParams = new URLSearchParams(window.location.search);
  
  return (
    <div className="paddingLarge">
      <div className="vaccination-div">
          <div className="heading-div">
            <img className="back-arrow" onClick={() => history.goBack()} src={backArrow} alt="arrow back"></img>
            <div className="heading">{t('VACCINATION_CATEGORY_HEADER')}</div>
          </div>
          <div className="list">
            <div className="list-item" onClick={() => history.push(`/vaccination-certificate/cowin?${urlParams.toString()}`)}>
              <div>
                <img className="list-icon" src={vaccineCerti} alt="express-interest"></img>
                {t("COWIN_CERTIFICATE_TEXT")}
              </div>
              <img className="next-arrow" src={nextArrow} alt="next-arrow"></img>
            </div>
            <div className="list-item" onClick={() => history.push(`/vaccination-certificate/reliance?${urlParams.toString()}`)}>
              <div>
                <img className="list-icon" src={vaccineCerti} alt="vaccination-certification"></img>
                {t('RELIANCE_COVID_19_VACCINATION_TEXT')}
              </div>
              <img className="next-arrow" src={nextArrow} alt="next-arrow"></img>
            </div>
          </div>
        </div>
    </div>
  );
};

export default VaccinationCertiCat;